<script>
export default {
  functional: true,
  props: {
    /**
     * Root element tag of this component.
     *
     * @values div, span, a, routerLink, etc...
     */
    tag: {
      type: String,
      default: 'div',
      required: true,
    },
  },

  render: function (h, ctx) {
    return h(
      ctx.props.tag,
      {
        class: { tab: true, active: ctx.data.attrs.tab.isActive },
        attrs: ctx.data.attrs.tab.attrs,
        listeners: ctx.listeners,
        on: {
          click: (event) => ctx.listeners.click(ctx.data.attrs.tab),
        },
      },
      /** @slot default slot */
      ctx.slots().default
    )
  },
}
</script>

<style lang="scss" scoped>
.tab {
  padding: rem(8px) 0;
  margin-bottom: -1px;
  font-size: rem(12px);
  color: $color-gray-400;
  text-decoration: none;
  cursor: pointer;
  border-bottom: none;

  @include unselectable();

  &:hover {
    color: $color-gray-500;
  }
  &:active {
    color: $color-gray-600;
  }

  &:not(:last-child) {
    margin-right: rem(20px);
  }

  @include createFlex(inline-flex, nowrap, row, flex-start, stretch, stretch);

  &.active {
    color: $primary;
    cursor: default;
    border-bottom: 2px solid $primary;
  }
}
</style>

<docs>
UiTab example:
```vue
<template>
  <div>
    <UiTab v-for="tab in tabs" :key="tab.key" tag="routerLink" :tab="tab" @click="$emit('tab-click', event)">
      {{ tab.label }}
    </UiTab>
  </div>
</template>

<script>
import UiTab from './UiTab.vue'

export default {
  components: { UiTab },
  data() {
    return {
      tabs: [
        {
          key: 'all',
          label: 'All',
          isActive: false,
          attrs: {
            to: {
              name: 'logs',
              query: { level: 1 },
            },
          },
        },
        {
          key: 'error',
          label: 'Errors',
          isActive: true,
          attrs: {},
        },
        {
          key: 'warnings',
          label: 'Warnings',
          isActive: false,
        },
        {
          key: 'user',
          label: 'User',
          isActive: false,
        },
        {
          key: 'info',
          label: 'Info',
          isActive: false,
        },

      ]
    }
  },
}
</script>
```

</docs>
